interface UpdateItem {
  time: string;
  title: string;
  summary: string;
}

const updates: UpdateItem[] = [
  {
    time: '10分钟前',
    title: '某知名歌手演唱会突发舞台事故，现场观众拍下惊险一幕',
    summary: '升降台故障导致演出中断15分钟，歌手反应获网友点赞。',
  },
  {
    time: '25分钟前',
    title: '两大顶流品牌代言争夺战白热化，双方团队暗地较劲',
    summary: '国际奢侈品牌亚太区代言人竞争进入最后阶段，结果即将揭晓。',
  },
  {
    time: '1小时前',
    title: '某综艺节目剪辑争议持续发酵，嘉宾发长文回应',
    summary: '节目组被指恶意剪辑制造矛盾，当事嘉宾晒出完整时间线反击。',
  },
  {
    time: '2小时前',
    title: '网传某影视公司资金链断裂，多个项目暂停拍摄',
    summary: '业内人士透露该公司拖欠剧组工资已达三个月，行业震荡。',
  },
  {
    time: '3小时前',
    title: '某电商主播涉嫌虚假宣传被立案调查，直播间已停播',
    summary: '市场监管部门介入，涉事产品已全部下架，赔偿方案正在协商。',
  },
  {
    time: '5小时前',
    title: '热门IP改编剧选角引发原著粉不满，官博评论区沦陷',
    summary: '书粉发起#请尊重原著#话题冲上热搜，制片人紧急回应。',
  },
  {
    time: '8小时前',
    title: '某国际电影节公布入围名单，三部华语片成功入选',
    summary: '其中一部新人导演作品成最大黑马，业内普遍看好其获奖前景。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            实时滚动更新，吃瓜节奏不停，每条快讯都值得关注
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-[11px] md:left-[15px] top-0 bottom-0 w-0.5 bg-background-200"></div>

            <div className="space-y-6 md:space-y-8">
              {updates.map((item, idx) => (
                <div key={idx} className="relative">
                  <div className="absolute -left-8 md:-left-10 top-1.5 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 border-primary-500 bg-background-100"></div>

                  <div className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer">
                    <span className="inline-block text-xs text-primary-500 font-medium mb-1.5">
                      {item.time}
                    </span>
                    <h3 className="text-sm font-medium text-foreground-800 mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">
                      {item.summary}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}